export default __webpack_public_path__ + "static/producto-fallback-479f3d79f8e5a0370a685e190ef44817.jpg";